const hostMapping = {
  's3-cinepolisgulf.enpointe.io': 's3-cinepolisgulf.enpointe.io' 
    // 'cinepoligulfcinema.gumlet.io': 'cinepoligulfcinema.gumlet.io' 

};

/**
 * @param {string} originalUrl 
 * @param {Object} options 
 * @returns {string}
 */
export const getGumletUrl = (originalUrl, options = {}) => {
  
  if (!originalUrl) return originalUrl;
  
  if (originalUrl.includes('gumlet.io')) return originalUrl;
  
  if (originalUrl.includes("/static")) return originalUrl;
  
  let imagePath = originalUrl;
  let gumletDomain = 's3-cinepolisgulf.enpointe.io'; 

  if (originalUrl.startsWith('http')) {
    try {
      const url = new URL(originalUrl);
      imagePath = url.pathname.startsWith('/') ? url.pathname.substring(1) : url.pathname;

      if (hostMapping[url.hostname]) {
        gumletDomain = hostMapping[url.hostname];
      }
    } catch (e) {
      console.error("Invalid URL:", originalUrl);
      return originalUrl;
    }
  }

  let gumletUrl = `https://${gumletDomain}/${imagePath}`;

  const queryParams = [];
  if (options.width) queryParams.push(`w=${options.width}`);
  if (options.height) queryParams.push(`h=${options.height}`);
  if (options.quality) queryParams.push(`q=${options.quality}`);
  if (options.format) queryParams.push(`f=${options.format}`);
  if (options.blur) queryParams.push(`blur=${options.blur}`);
  if (options.autoFormat) queryParams.push('auto=format');
  if (options.responsive) queryParams.push('width=auto');
  if (options.dpr) queryParams.push(`dpr=${options.dpr}`);
  if (options.other) {
    Object.entries(options.other).forEach(([key, value]) => {
      queryParams.push(`${key}=${value}`);
    });
  }

  if (queryParams.length > 0) {
    gumletUrl += `?${queryParams.join('&')}`;
  }

  return gumletUrl;
};